<template>
  <div>
    <editor-wizard v-if="showWizard" :group="group" :prefill="lastWizardData"
                   @cancel="showWizard = false"
                   @pageGenerated="wizardDone"/>
    <yes-no-modal v-if="showWizardAck" additional-text="Existing page text will be overwritten."
                  @no="showWizardAck = false"
                  @yes="wizardAckDone"/>

    <mdb-modal :show="showImageSelector" removeBackdrop scrollable @close="showImageSelector = false" class="gp-z-2000">
      <mdb-modal-header :close="true" center class="secondary-color text-white">Select an Image
      </mdb-modal-header>
      <mdb-modal-body>
        <image-selector :group="group" emitOnSelection="imageSelected" @imageSelected="imageSelected"/>
      </mdb-modal-body>
    </mdb-modal>

    <div v-if="!showWizard">
      <div class="formless-label">{{ label }}</div>
      <div id="text-wizard-area" class="grey lighten-5 border">
        <tiny-editor v-model="textBody" v-if="editorConfig" :init="editorConfig"/>
        <div class="gp-end-wrap">&nbsp;</div>
        <mdb-btn v-if="allowWizard" icon="hat-wizard" rounded size="sm" @click="startWizard()">Use Page Wizard</mdb-btn>
      </div>
    </div>
  </div>

</template>

<script>
import {mdbBtn, mdbModal, mdbModalHeader, mdbModalBody} from 'mdbvue';
import ImageSelector from "../group/ImageSelector";
import SystemImageSelector from "../admin/SystemImageSelector";
import editorSettings from "../../services/editorSettings";
import tinyEditor from '@tinymce/tinymce-vue'
import EditorWizard from "../common/EditorWizard";
import YesNoModal from "../common/YesNoModal";

export default {
  name: 'Group-Editor',
  components: {
    mdbBtn, mdbModal, mdbModalHeader, mdbModalBody,
    ImageSelector,
    SystemImageSelector,
    tinyEditor,
    EditorWizard,
    YesNoModal
  },
  data() {
    return {
      editorConfig: null,
      imageSelector: false,
      showImageSelector: false,
      lastWizardData: null,
      showWizard: false,
      showWizardAck: false,
      wizardAcknowledged: false,
    }
  },
  props: {
    field: {
      type: String,
      default: null
    },
    group: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: "Body"
    },
    allowWizard: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    textBody: {
      get() {
        return this.field
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    settings() {
      return this.$store.state.settings
    }
  },
  mounted() {
    this.editorConfig = editorSettings.theWorksInline()
    this.editorConfig.file_picker_callback = this.myFileBrowser
  },
  methods: {
    startWizard() {
      if (this.textBody) this.showWizardAck = true
      if (!this.showWizardAck) this.showWizard = true
    },
    wizardAckDone() {
      this.showWizardAck = false
      this.showWizard = true
    },
    wizardDone: function (result) {
      this.showWizard = false
      this.textBody = result.html
      this.lastWizardData = result
      this.$notify.success({message: "Page generated.", timeOut: 5000})
      this.$emit("wizardDone")
    },
    imageSelected: function (image) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      if (el[0]) el[0].setAttribute("style", "display:block")

      this.showImageSelector = false
      this.imageCallback(image.url, {width: "33%", height: ""})
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      if (el[0]) el[0].setAttribute("style", "display:none")
      this.showImageSelector = true
      this.imageCallback = callBack
    }

  }
};
</script>

